import { render, staticRenderFns } from "./card-list.vue?vue&type=template&id=44048d28"
import script from "./card-list.vue?vue&type=script&lang=js"
export * from "./card-list.vue?vue&type=script&lang=js"
import style0 from "./card-list.vue?vue&type=style&index=0&id=44048d28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports